// HOME PAGE JS - START
if (document.body.classList.contains("template-index")) {

  // section => hero icon section
  let homeIcon = document.querySelector('.hero-icon-section .text-with-icons__blocks') || null;
  if(homeIcon){
    heroIconSlider();
  }

  // section => featured-collection.liquid
  let homeProdList = document.querySelector(".home-product-list [data-featured-collection]") || null;
  if(homeProdList){
    homeProdListSlider();
    //custom AK
    featurecollSectionSlider(homeProdList);
  }

  // section - testimonials.liquid
  let testiSection = document.querySelector(".testimonials-section") || null;
  if(testiSection) testiSectionSlider(testiSection);

  // section - collection-list section
  let collList = document.querySelector('.collection-list-section .grid.grid--uniform') || null;
  if(collList){
    collListSlider();
  }

  if($(window).width() > 1080 ){
    let fullwidth = $(window).width();
    let cont_width = $('.home-imagetext-section .page-width').width();
    let padd = ((fullwidth - cont_width)/2) - 20 ;
    $('.home-product-list .page-width.mains').css("padding-left", padd);
    $('.home-product-list .page-width:not(.mains)').css("padding-left", padd);
    let paddright = ((fullwidth - cont_width)/2) - 150 ;
    $('.home-product-list .page-width:not(.mains)').css("padding-right", paddright);
  }

}
// HOME PAGE JS - END


let f_width = $(window).width(); 
let sec_width = $('.site-footer .page-width').width();
let sec_pad = (f_width - sec_width)/2;
 
$('product-recommendations .page-width').css("padding-left",sec_pad); 



// Product PAGE JS - START
if (document.body.classList.contains("template-product")){
 
  var isALARendered;
  function ALAcheck() {
    isALARendered = setInterval(function () {
      customALA()
    }, 700);
  }
  ALAcheck();
  function customALA() {
  var selector = document.querySelectorAll('.related_products .grid.grid--uniform .grid-product');
    if($(window).width() < 767){
    if(selector.length > 2){
      clearInterval(isALARendered); 
      var arrow_element = document.querySelector('.custom-arrow-main');
         arrow_element.classList.add('hide');
      var elem = document.querySelector('.related_products .grid.grid--uniform');
      var flkty = new Flickity( elem, {
        wrapAround: true,
        pageDots: false,
        initialIndex: 1,
        autoPlay: false,
        prevNextButtons: true,
        cellAlign: 'left'
      }); 

      var main_elem = document.querySelector('.related_products');
      if(main_elem){
       relatedSectionSlider(main_elem);
      }
    }
    }else{
       if(selector.length > 4){
      clearInterval(isALARendered);          
      var arrow_element = document.querySelector('.custom-arrow-main');
         arrow_element.classList.remove('hide');
         
      var elem = document.querySelector('.related_products .grid.grid--uniform');
      var flkty = new Flickity( elem, {
        wrapAround: true,
        pageDots: false,
        initialIndex: 1,
        autoPlay: false,
        prevNextButtons: true,
        cellAlign: 'left'
      }); 

      var main_elem = document.querySelector('.related_products');
      if(main_elem){
       relatedSectionSlider(main_elem);
      }
    }
    }
    
  }
}


// Product PAGE JS - END
// Collection PAGE JS - START
if (document.body.classList.contains("template-collection")){
  $(document).on('click','.dropdown .select',function(e){
      $(this).parent('.dropdown').attr('tabindex', 1).focus();
      $(this).parent('.dropdown').toggleClass('active');
      $(this).parent('.dropdown').find('.dropdown-menu').slideToggle(300);
   });
  $(document).on('click','.dropdown .dropdown-menu li',function(){
    // $(this).parents('.dropdown').find('span').text($(this).text());
    // $(this).parents('.dropdown').find('input').attr('value', $(this).attr('id'));
    var value = $(this).attr('value');
    $(this).siblings('li').removeClass('selected');
    $(this).addClass('selected');
    var sortBySelect = document.querySelector("select#SortBy"); 
    sortBySelect.value = value; 
    sortBySelect.dispatchEvent(new Event("change"));
  });
}
// Collection PAGE JS - END


function heroIconSlider() {
  if($(window).width() < 1080 ){
    var elem = document.querySelector('.hero-icon-section .text-with-icons__blocks');
    var flkty = new Flickity( elem, {
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      autoPlay: 1500 ,
       prevNextButtons: false,
      adaptiveHeight: true
    }); 
  }
}

function homeProdListSlider() {
  let homeProdList = document.querySelector(".home-product-list [data-featured-collection]") || null;
  let slider_main = new Flickity(homeProdList,{
    wrapAround: true,
    pageDots: false,
    initialIndex: 1,
    autoPlay: false,
    // prevNextButtons: false,
     cellAlign: 'left'
  });
 
}

function testiSectionSlider(testiSection) {
  let testiPrev = testiSection.querySelector(".custom-flickity-previous") || null;
  let testiNext = testiSection.querySelector(".custom-flickity-next") || null;
  if(testiPrev){
    testiPrev.addEventListener("click",function(e){
      e.preventDefault();
      let sliderPrev = testiSection.querySelector(".flickity-previous") || null;
      if(sliderPrev) sliderPrev.click();
    });
  }
  if(testiNext){
    testiNext.addEventListener("click",function(e){
      e.preventDefault();
      let sliderNext = testiSection.querySelector(".flickity-next") || null;
      if(sliderNext) sliderNext.click();
    });
  }
}

//home feature-collection slider
function featurecollSectionSlider(homeProdList) {
  let main_div = document.querySelector(".home-product-list") || null;
  
  let featurecollPrev = main_div.querySelector(".custom-flickity-previous") || null;
  let featurecollNext = main_div.querySelector(".custom-flickity-next") || null;
  if(featurecollPrev){
    featurecollPrev.addEventListener("click",function(e){
      e.preventDefault();
      console.log('hh')
      let sliderPrev = homeProdList.querySelector(".flickity-previous") || null;
      if(sliderPrev) sliderPrev.click();
    });
  }
  if(featurecollNext){
    featurecollNext.addEventListener("click",function(e){
      e.preventDefault();
      let sliderNext = homeProdList.querySelector(".flickity-next") || null;
      if(sliderNext) sliderNext.click();
    });
  }
}
function relatedSectionSlider(elem){
  let featurecollPrev = elem.querySelector(".custom-flickity-previous") || null;
  let featurecollNext = elem.querySelector(".custom-flickity-next") || null;
  if(featurecollPrev){
    featurecollPrev.addEventListener("click",function(e){
      e.preventDefault();
      let sliderPrev = elem.querySelector(".flickity-previous") || null;
      if(sliderPrev) sliderPrev.click();
    });
  }
  if(featurecollNext){
    featurecollNext.addEventListener("click",function(e){
      e.preventDefault();
      let sliderNext = elem.querySelector(".flickity-next") || null;
      if(sliderNext) sliderNext.click();
    });
  }
}

function collListSlider() {
  if($(window).width() < 769 ){
    var elem = document.querySelector('.collection-list-section .grid.grid--uniform');
    var flkty = new Flickity( elem, {
      // options
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      pageDots: true, 
       prevNextButtons: true
    }); 
  }
}

// upsell js in cart drawer

$(document).on('click', '.upsell_products_drawer .addcart-btn',function(){
  var pro_id = $(this).data("pro-id");
  let arr = [];
  arr.push({id: pro_id, quantity: 1 });   
  let formData = {'items': arr};
  fetch('/cart/add.js', {
    body: JSON.stringify(formData),
    credentials: 'same-origin',
    headers: {
    'Content-Type': 'application/json',
    'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  }).then((response) => {
  return response.json();
  }).then((res) => {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    if(res.status && res.status == 422){
    console.log("Inventory Error !");
    }else{
    console.log("Success !");
    }
  }).catch((err) => {
  /* uh oh, we have error. */
    console.error(err)
  });
});


if($(window).width() < 991 ){
  var elem2 = document.querySelector('.values-main .values-inner');
  var flkty2 = new Flickity( elem2, {
    // options
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    pageDots: true, 
    prevNextButtons: true
  }); 

  var maxHeight = 0;
  $(".values-main .values").each(function(){
    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".values-main .values").height(maxHeight);
}

// Login/Register Password hide show js
$('.show_pass').on('click', function(){
  var passInput=$(".hs_pass");
  if(passInput.attr('type')==='password')
    {
      passInput.attr('type','text');
      $(".show_pass").addClass('active_pass');
  }else{
     passInput.attr('type','password');
    $(".show_pass").removeClass('active_pass');
  }
});

$( document ).ready(function() {
// Geolocation JS for replace the word
// if($('body').html().indexOf("Walnussöl") > 0) { 
//    $.ajax({
//       url:"//get.geojs.io/v1/ip/country.json",
//       type:"GET",
//       dataType:"json",
//       success:function(s){		
//         console.log("s.country", s.country, s)
//         // if(s.country == "CH"){          
//         //   var strNewString = $('body').html().replace(/Walnussöl/g,'Baumnussöl');
//         //   $('body').html(strNewString);
//         // } 		
//       }
//     });
// }

  // Shipping Popup Js Start
  var modal = document.getElementById("shippingModal");
  
  var btn = document.getElementById("shipping_popup_Btn");
  
  var span = document.getElementsByClassName("close")[0];
  
  btn.onclick = function() {
    modal.style.display = "flex";
  }
  span.onclick = function() {
    modal.style.display = "none";
  }
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }

  $('#shipping_popup_Btn').click(function(){
      $('.drawer__close-button').click();
  });
  // Shipping Popup Js End

  ///pre-order popup js
  setTimeout(function() {
    $('body.product-preorder').addClass('preoderpopup-active');
        $(".preoperder-popup").fadeIn( "slow", function() {
        });
  }, 3000);
  
  $(document).on('click',function(event){
    // console.log("document click");
    var container = $(".preoperder-popup .inner_content");
    if (!container.is(event.target) && !container.has(event.target).length) {
      $("body").removeClass('preoderpopup-active');
      $(".preoperder-popup").fadeOut( "slow", function() {});
    }
  });
  
  $(document).on('click', ".preoperder-popup a.btn", function(event) {
      event.preventDefault();
      // console.log("click check");
      $(".product-single__form .add-to-cart").trigger("click");
      setTimeout(function() {
          // $(".preoperder-popup .close_btn").trigger("click");
      }, 100);
  });
  
  
  $(".close_btn").click(function() {
    $('body').removeClass('preoderpopup-active'); 
    $(".preoperder-popup").fadeOut( "slow", function() {
    });
  });
  
});
// document ready -- end





/* ***This will only render in the theme editor / customiser***** */
if (Shopify.designMode) {
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("shopify:section:load", function () {
      // section => featured-collection.liquid
      const proslider = event.target.closest(".home-product-list [data-featured-collection]") || null;
      if (proslider) {
        homeProdListSlider();
      }
    });
  });
}